import type { Location } from '../data/locations';

export function createInfoWindow(location: Location): string {
  return `
    <div class="p-4 max-w-xs">
      <h3 class="text-lg font-semibold mb-2">${location.name}</h3>
      <div class="space-y-2 text-sm">
        <p class="text-gray-600">${location.storeName}</p>
        <p>${location.address}</p>
        <p>${location.city}, ${location.state} ${location.zip}</p>
        <div class="mt-4">
          <p class="font-medium">Features:</p>
          <p>${location.btmFeatures.type}</p>
          <p>Limits: $${location.btmFeatures.limits.min} - $${location.btmFeatures.limits.max.toLocaleString()}</p>
        </div>
      </div>
    </div>
  `;
}

export function isLocationInTexas(lat: number, lng: number): boolean {
  const TEXAS_BOUNDS = {
    north: 36.5007,
    south: 25.8371,
    west: -106.6452,
    east: -93.5083
  };

  return (
    lat >= TEXAS_BOUNDS.south &&
    lat <= TEXAS_BOUNDS.north &&
    lng >= TEXAS_BOUNDS.west &&
    lng <= TEXAS_BOUNDS.east
  );
}